(() => {
  const setup = () => document.querySelectorAll('.jb-inline-search').forEach(root => {
    if (root.dataset.predictiveReady) return;
    root.dataset.predictiveReady = 'true';
    const input = root.querySelector('input[type="search"]');
    const form = root.querySelector('form');
    if (!input || !form) return;
    const panel = document.createElement('div');
    panel.className = 'jb-search-suggestions';
    panel.id = input.id + '-suggestions';
    panel.hidden = true;
    const list = document.createElement('div');
    list.id = panel.id + '-list';
    list.setAttribute('role', 'listbox');
    const status = document.createElement('p');
    status.className = 'jb-search-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    panel.append(status, list);
    root.append(panel);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');
    let timer, controller, active = -1, sequence = 0;
    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; };
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const safeUrl = value => {
      const url = new URL(value, location.origin);
      return url.origin === location.origin ? url.href : form.action;
    };
    const search = async term => {
      const version = ++sequence;
      controller?.abort();
      controller = new AbortController();
      list.replaceChildren();
      status.textContent = root.dataset.loading;
      open();
      try {
        const base = window.Shopify?.routes?.root || '/';
        const url = new URL(base + 'search/suggest.json', location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title');
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (version !== sequence || input.value.trim() !== term) return;
        const products = data.resources?.results?.products || [];
        status.textContent = products.length ? root.dataset.results : root.dataset.empty;
        const currency = window.Shopify?.currency?.active || 'USD';
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency});
        products.forEach((product, index) => {
          const link = document.createElement('a');
          link.href = safeUrl(product.url);
          link.id = panel.id + '-' + index;
          link.className = 'jb-search-result';
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          link.tabIndex = -1;
          const imageUrl = product.featured_image?.url || product.image;
          if (imageUrl) {
            const img = document.createElement('img');
            const image = new URL(imageUrl, location.origin);
            if (image.protocol === 'https:') { image.searchParams.set('width','120'); img.src = image.href; }
            img.alt = '';
            img.width = 52; img.height = 52;
            link.append(img);
          }
          const text = document.createElement('span');
          const title = document.createElement('span');
          title.className = 'jb-search-result-title'; title.textContent = product.title;
          const price = document.createElement('span');
          price.className = 'jb-search-result-price'; price.textContent = formatter.format(Number(product.price));
          text.append(title, price); link.append(text); list.append(link);
        });
        const all = document.createElement('a');
        const allUrl = new URL(form.action); allUrl.searchParams.set('q',term); allUrl.searchParams.set('type','product');
        all.href = allUrl.href; all.className = 'jb-search-view-all';
        all.id = panel.id + '-all'; all.setAttribute('role','option'); all.setAttribute('aria-selected','false'); all.tabIndex = -1;
        all.textContent = root.dataset.viewAll + ' “' + term + '” →'; list.append(all);
        open();
      } catch (error) {
        if (error.name === 'AbortError' || version !== sequence) return;
        close();
      }
    };
    input.addEventListener('input', () => {
      clearTimeout(timer); ++sequence; controller?.abort(); close();
      const term = input.value.trim();
      if (term.length >= 2) timer = setTimeout(() => search(term), 220);
    });
    input.addEventListener('focus', () => { if (list.children.length && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { clearTimeout(timer); ++sequence; controller?.abort(); close(); return; }
      const options = [...list.querySelectorAll('[role="option"]')];
      if (panel.hidden || !options.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        active = event.key === 'ArrowDown' ? (active + 1) % options.length : (active - 1 + options.length) % options.length;
        options.forEach((item,index) => item.setAttribute('aria-selected', String(index === active)));
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({block:'nearest'});
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault(); location.assign(options[active].href);
      }
    });
    document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) close(); });
    root.addEventListener('focusout', () => setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0));
    form.addEventListener('submit', close);
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
